export function getCreateRequestData(context) {
    return {
        correlationId: context.correlationId,
        getAccessToken: context.getAccessToken,
        jwtAuthEnabled: context.jwtAuthEnabled,
        officeHomeApiRoot: context.officeHomeApiRoot,
    };
}
//# sourceMappingURL=getCreateRequestData.js.map